module.exports = __webpack_public_path__ + "static/media/404_illustration.26e37496.gif";